// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remove[data-v-51156ce6] {\n  color: #F56C6C;\n}\n", ""]);
// Exports
module.exports = exports;
